module.exports = __webpack_public_path__ + "components/gallery-upload-button/static/icon-upload-40a1a8a94c920f6001bbdfd32c313910.svg";